import Comment from './comment'

export default Comment
